// Product catalog for OSS Ottawa one-page menu.
// Images sourced from curated stock libraries per design guidelines.

export const SHOP = {
  name: "One Stop Shop",
  short: "OSS",
  city: "Ottawa / Gatineau",
  tagline: "Anytime. Anything. Anywhere.",
  hours: "24/7",
  // NOTE: Replace this with the real shop number. Format E.164 for sms: links.
  phone: "+16132222775",
  phoneDisplay: "(613) 222-2775",
  freeDeliveryThreshold: 120,
  premiumNote: "$100 bottles — text us for pricing & everyday deals",
};

export const CATEGORIES = [
  {
    id: "liquor",
    name: "Liquor",
    blurb: "Top-shelf spirits, mickeys & 26ers",
    image:
      "https://images.pexels.com/photos/3407777/pexels-photo-3407777.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "wine",
    name: "Wine",
    blurb: "Reds, whites, rosé & bubbles",
    image:
      "https://images.pexels.com/photos/2702805/pexels-photo-2702805.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "cali-brick",
    name: "Cali Brick",
    blurb: "7g $70 · 14g $120",
    image:
      "https://images.unsplash.com/photo-1503262028195-93c528f03218?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "indica",
    name: "Indica",
    blurb: "7g $50",
    image:
      "https://images.unsplash.com/photo-1635791551959-e2282b331af3?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "sativa",
    name: "Sativa",
    blurb: "7g $50",
    image:
      "https://images.unsplash.com/photo-1603909223429-69bb7101f420?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=940",
  },
  {
    id: "oz-deals",
    name: "Oz Deals",
    blurb: "28g $100",
    image:
      "https://images.pexels.com/photos/7667731/pexels-photo-7667731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "hash",
    name: "Hash",
    blurb: "7g $50",
    image:
      "https://images.pexels.com/photos/7667724/pexels-photo-7667724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "nic-vapes",
    name: "Nic Vapes 50%",
    blurb: "Pulse, Ovns & STLTH",
    image:
      "https://images.pexels.com/photos/1047317/pexels-photo-1047317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "thc-vapes",
    name: "THC Vapes",
    blurb: "Gas Gang $50",
    image:
      "https://images.pexels.com/photos/17774111/pexels-photo-17774111.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "shatter",
    name: "Shatter",
    blurb: "1g $50",
    image:
      "https://images.unsplash.com/photo-1686043626878-9e391a70632d?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
  },
  {
    id: "shrooms",
    name: "Shrooms",
    blurb: "7g $50",
    image:
      "https://images.pexels.com/photos/13695325/pexels-photo-13695325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "edibles",
    name: "Edibles",
    blurb: "Gummies, chocolates, baked",
    image:
      "https://images.pexels.com/photos/11178475/pexels-photo-11178475.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "prerolls",
    name: "Pre-rolls",
    blurb: "Singles, packs & blunts",
    image:
      "https://images.pexels.com/photos/7824268/pexels-photo-7824268.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "shisha-tobacco",
    name: "Shisha Tobacco",
    blurb: "$25 each · mint blends & classics",
    image:
      "https://images.pexels.com/photos/11211460/pexels-photo-11211460.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];
